import type { UploadConfig } from '@/lib/fileLibraryUploadConfig';
import DocumentForm from './DocumentForm';

interface Document {
  id: number;
  name: string;
  description: string;
  file_path?: string;
  status?: string;
  vectorized_status?: string;
  update_cadence?: string;
}

interface DocumentEditProps {
  document: Document;
  errors: Record<string, string[]>;
  stateOptions: string[];
  fileLibraryUpload: UploadConfig;
}

export default function DocumentEdit({ document, errors = {}, stateOptions, fileLibraryUpload }: DocumentEditProps) {
  return (
    <DocumentForm
      document={document}
      isEdit={true}
      errors={errors}
      stateOptions={stateOptions}
      fileLibraryUpload={fileLibraryUpload}
    />
  );
}